import { useQuery } from '@tanstack/react-query';
import { getRoomSettings } from './requests';
import { useAppContext } from '@common/contexts/AppContext';

export const roomSettingsKeys = {
  roomSettings: ({ siteSlug }: { siteSlug: string }) => ['roomSettings', siteSlug] as const,
};

export function useRoomSettings(enabled = true) {
  const { siteSlug } = useAppContext();

  return useQuery({
    queryKey: roomSettingsKeys.roomSettings({ siteSlug }),
    queryFn: () => getRoomSettings({ siteSlug }),
    staleTime: Infinity,
    cacheTime: Infinity,
    enabled,
  });
}
